import { API, keys } from 'consts';
import { get, post } from 'api/api';
import { PaymentPlan } from './types/owner';
import { loadStripe } from '@stripe/stripe-js';

export const refreshAccountLink = (payoutMethodId) => {
  window.location.href = `${API.root}services/stripe/refresh/${payoutMethodId}/`;
};

type StripeCheckoutSessionResponse = {
  session: string;
  url: string;
  message?: string;
};

type StripeLoginLink = {
  object: 'login_link';
  created: number;
  url: string;
};

export const getDashboardLink = (payoutMethodId) => {
  return get<StripeLoginLink>(`/services/stripe/login/${payoutMethodId}/`);
};

export type StripePaymentPlan = {
  displayName: string;
  planType: PaymentPlan;
  currency: string;
  price: number;
  lookupKey?: string;
  priceId?: string;
  product?: string;
  interval?: 'month' | 'year';
  image?: string;
};

export const getPaymentPlans = () => {
  return get<StripePaymentPlan[]>('/services/stripe/plans/');
};

export const createPaymentPlanCheckout = async (
  paymentPlanId: string,
  toltCustomerId: string | null,
) => {
  const response = await post<StripeCheckoutSessionResponse>(
    `/services/stripe/subscribe/${paymentPlanId}/`,
    {
      tolt_customer_id: toltCustomerId,
    },
  );
  if (!response.ok) {
    throw new Error(response.data.message);
  }
  const sessionId = response.data?.session;
  const stripe = await loadStripe(keys.stripe);
  const redirectToCheckout = await stripe.redirectToCheckout({
    sessionId,
  });

  if (redirectToCheckout.error) {
    throw new Error(redirectToCheckout.error.message);
  }
};

export const getSubscriptionManagementLink = () => {
  return post<{ url: string }>(`/services/stripe/subscription/manage/`);
};
